import ProtectedRoute from "@components/ProtectedRoute";
import { PagesID } from "@utils/utilsConfigurations";
import { useIsInclude } from "src/router/RoutersCst";

import AddTerm from "@pages/Contents/Corporate/Initiative/TaxonomyTerms/AddTerm";
import EditTerm from "@pages/Contents/Corporate/Initiative/TaxonomyTerms/EditTerm";

import TaxonomyTerms from "@pages/Contents/Corporate/Initiative/TaxonomyTerms";

const useCorporateTerms = () => {
  const { isInclude } = useIsInclude();

  return {
    path: "terms",
    children: [
      {
        index: true,
        path: "",
        element: (
          <ProtectedRoute
            isAllowed={isInclude(
              "corporate&&corporate.initiative&&cms.wrapper.moderatedterms.read"
            )}
          >
            <TaxonomyTerms
              page={PagesID["corporate.initiative.discussion.terms"]}
            />
          </ProtectedRoute>
        ),
      },
      {
        index: true,
        path: "add",
        element: (
          <ProtectedRoute
            isAllowed={isInclude(
              "corporate&&corporate.initiative&&cms.wrapper.moderatedterms.add"
            )}
          >
            <AddTerm
              page={PagesID["corporate.initiative.discussion.terms.add"]}
            />
          </ProtectedRoute>
        ),
      },
      {
        index: true,
        path: "edit/:termId",
        element: (
          <ProtectedRoute
            isAllowed={isInclude(
              "corporate&&corporate.initiative&&cms.wrapper.moderatedterms.update"
            )}
          >
            <EditTerm
              page={PagesID["corporate.initiative.discussion.terms.edit"]}
            />
          </ProtectedRoute>
        ),
      },
    ],
  };
};

export default useCorporateTerms;
